import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
import { useCart } from '../pages/CartContext'; // Assuming you have a cart context
import { FaShoppingCart } from 'react-icons/fa'; // Using FontAwesome cart icon
import { useAuth } from '../pages/AuthContext';
import { useI18n } from '../i18n/I18nContext';
import LanguageSelector from './LanguageSelector';

const Header = () => {
  const { cart } = useCart(); // Get the cart state
  const { user, loading, logout } = useAuth();
  const { t } = useI18n();
  const cartItemCount = cart.reduce((total, item) => total + item.quantity, 0); // Calculate total items

  return (
    <header className="header">
      <div className="header-top">
        <img
          className="ych-yoyo-logo"
          src="/images/ych_yoyo_logo.jpg"
          alt={t('header.logoAlt')}
        />

        <div className="header-actions">
          <LanguageSelector />
          {!loading && (
            <div className="auth-actions">
              {user ? (
                <>
                  <Link to="/account" className="auth-link">{t('header.account')}</Link>
                  {user.role === 'admin' && <Link to="/admin/radar" className="auth-link">{t('radar.title')}</Link>}
                  {user.role === 'admin' && <Link to="/admin/analytics" className="auth-link">{t('analytics.nav')}</Link>}
                  <button type="button" className="auth-button" onClick={logout}>
                    {t('header.logout')}
                  </button>
                </>
              ) : (
                <>
                  <Link to="/login" className="auth-link">{t('header.login')}</Link>
                  <Link to="/register" className="auth-link">{t('header.register')}</Link>
                </>
              )}
            </div>
          )}

          <div className="cart-icon">
            <Link to="/cart" data-analytics-target="header_cart" aria-label={t('header.cart')}>
              <FaShoppingCart size={24} />
              {cartItemCount > 0 && <span className="cart-badge">{cartItemCount}</span>}
            </Link>
          </div>
        </div>
      </div>

      <div className="logo">YCH-YOYO</div>

      <nav className="nav-links">
        <Link to="/" data-analytics-target="nav_home">{t('nav.home')}</Link>
        <Link to="/store" data-analytics-target="nav_store">{t('nav.store')}</Link>
        <Link to="/customizer" data-analytics-target="nav_customizer" className="nav-link-with-badge">
          {t('nav.customYoyo')}
          <span className="nav-new-badge" aria-hidden="true">{t('badge.featured')}</span>
        </Link>
        <Link to="/custom-design" data-analytics-target="nav_custom_design">{t('nav.customDesign')}</Link>
        <Link to="/team" data-analytics-target="nav_team">{t('nav.team')}</Link>
        <Link to="/stories" data-analytics-target="nav_stories">{t('nav.stories')}</Link>
        <Link to="/community/scoring" data-analytics-target="nav_video_scoring" className="nav-link-with-badge">
          {t('nav.videoScoring')}
          <span className="nav-new-badge" aria-hidden="true">{t('badge.featured')}</span>
        </Link>
        <Link to="/community" data-analytics-target="nav_community" className="nav-link-with-badge">
          {t('nav.community')}
          <span className="nav-new-badge" aria-hidden="true">{t('badge.new')}</span>
        </Link>
        <Link to="/guides/blitzball-vs-windball" data-analytics-target="nav_guide">{t('nav.guide')}</Link>
        <Link to="/shipping" data-analytics-target="nav_shipping">{t('nav.shipping')}</Link>
        <Link to="/contact" data-analytics-target="nav_contact">{t('nav.contact')}</Link>
      </nav>
    </header>
  );
};

export default Header;
